export default __webpack_public_path__ + "static/media/home-image.ad9b8f74.png";